<div class="export-dialog-content">
  <!-- Data Scope Section -->
  <div class="section">
    <label class="section-label">Data to Export:</label>
    <div class="radio-group">
      <div class="radio-option">
        <p-radioButton 
          name="dataScope" 
          value="filtered" 
          [(ngModel)]="dataScope"
          inputId="scopeFiltered">
        </p-radioButton>
        <label for="scopeFiltered" class="radio-label">
          Export filtered data
          <span class="hint" *ngIf="hasActiveFilters()">(current filters applied)</span>
          <span class="hint" *ngIf="!hasActiveFilters()">(no filters active)</span>
        </label>
      </div>
      <div class="radio-option">
        <p-radioButton 
          name="dataScope" 
          value="all" 
          [(ngModel)]="dataScope"
          inputId="scopeAll">
        </p-radioButton>
        <label for="scopeAll" class="radio-label">Export all data</label>
      </div>
    </div>
  </div>

  <!-- Column Selection Section -->
  <div class="section">
    <label class="section-label">Select Columns:</label>
    <div class="columns-list">
      <!-- Select All -->
      <div class="column-item select-all">
        <p-checkbox 
          [(ngModel)]="selectAll" 
          [binary]="true" 
          inputId="selectAll"
          (ngModelChange)="onSelectAllChange($event)">
        </p-checkbox>
        <label for="selectAll" class="column-label select-all-label">Select All</label>
      </div>
      
      <!-- Individual Columns -->
      <div class="column-item" *ngFor="let column of columns">
        <p-checkbox 
          [ngModel]="isColumnSelected(column.key)" 
          [binary]="true" 
          [inputId]="'col_' + column.key"
          (ngModelChange)="toggleColumn(column.key)">
        </p-checkbox>
        <label [for]="'col_' + column.key" class="column-label">{{ column.header }}</label>
      </div>
    </div>
    
    <div class="validation-message" *ngIf="selectedColumns.length === 0">
      Please select at least one column to export.
    </div>
  </div>

  <!-- Format Selection Section -->
  <div class="section">
    <label class="section-label">Export Format:</label>
    <p-select 
      [(ngModel)]="exportFormat" 
      [options]="formatOptions" 
      optionLabel="label" 
      optionValue="value"
      styleClass="format-select">
    </p-select>
  </div>
</div>

<!-- Footer Actions -->
<div class="dialog-footer">
  <a class="manage-exports-link" (click)="goToManageExports()">
    <i class="pi pi-external-link"></i> Manage Exports
  </a>
  <div class="action-buttons">
    <button 
      type="button" 
      pButton 
      label="Cancel" 
      class="p-button-outlined"
      (click)="onCancel()">
    </button>
    <button 
      type="button" 
      pButton 
      label="Start Export" 
      [disabled]="selectedColumns.length === 0"
      (click)="onStartExport()">
    </button>
  </div>
</div>
